import * as types from '../../types'
import Immutable from 'immutable'

const INITIAL_STATE = Immutable.fromJS({
    saving: false,
})

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.BOILERPLATE_REINICIAR_ESTADO:
            return INITIAL_STATE
        case types.BOILERPLATE_GUARDANDO:
            state = state.set('saving', action.payload)
            return state
        default:
            return state
    }
}